import { render, staticRenderFns } from "./VCurrencyBalance.vue?vue&type=template&id=058967ea&scoped=true&"
import script from "./VCurrencyBalance.vue?vue&type=script&lang=js&"
export * from "./VCurrencyBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058967ea",
  null
  
)

export default component.exports